import React, { type ReactNode } from 'react';

import Heading, { HeadingContextProvider } from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives';

import { ProgressBar } from './ProgressBar';

type StorageLimitsProps = {
	title: string;
	/** If using `<Text />`, set the prop `size="small"` to ensure it matches the design */
	description: ReactNode;
	/** This will be treated as the same unit type as limit */
	used: number;
	/** This will be treated as the same unit type as used */
	limit: number;
	/**
	 * This is the descriptive label that's associated with the progress bar.
	 * Always include useful information on the current state of the progress bar so that people who use assistive technology can understand what the current state of the progress bar is.
	 */
	ariaLabel?: string;

	/**
	 * This is to show the base limit of a storage plan
	 */
	baseLimit?: {
		limit: number;
		title: string;
	};
};

export const StorageLimits = ({
	title,
	description,
	used,
	limit,
	ariaLabel,
	baseLimit,
}: StorageLimitsProps) => {
	return (
		<HeadingContextProvider>
			<Stack space="space.200">
				<Stack>
					<Heading size="small">{title}</Heading>
					<Text size="small" color="color.text.subtlest">
						{description}
					</Text>
				</Stack>
				<ProgressBar
					value={used / limit}
					ariaLabel={ariaLabel}
					baseLimit={baseLimit}
					limit={limit}
				/>
			</Stack>
		</HeadingContextProvider>
	);
};
